






















import Vue from 'vue'
import PersonsAutocomplete from '@/components/PersonsAutoComplete.vue'
export default Vue.extend({
    components: { PersonsAutocomplete },
    props: {
        loader: {
            type: Boolean,
            default: false
        }
    }
})
